const Index = () => import("./index.vue");

export default [
  {
    path: "/stock/taking",
    component: Index,
  },
];
